// extracted by mini-css-extract-plugin
export default {"white":"#fff","black":"#000"};